import React from "react";
import {
  SafetyOutlined,
  ClockCircleOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const DestinationHeader = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="destination-header-container">
        <p className="destination-header-title remove-pointer-events">
          {t("kaleiaHeading")}
        </p>
        <div className="destination-header-icon-container">
          <div className="destination-header-icon-item-gap-10">
            <DashboardOutlined className="destination-header-icon-item-icon-28" />
            <p className="destination-header-icon-item-text remove-pointer-events ">
              {t("fast")}
            </p>
          </div>
          <div className="destination-header-icon-item-gap-5">
            <SafetyOutlined className="destination-header-icon-item-icon-32" />
            <p className="destination-header-icon-item-text remove-pointer-events ">
              {t("secure")}
            </p>
          </div>
          <div className="destination-header-icon-item-gap-10">
            <ClockCircleOutlined className="destination-header-icon-item-icon-28" />
            <p className="destination-header-icon-item-text remove-pointer-events ">
              24/7
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DestinationHeader;
